module.exports = __webpack_public_path__ + "img/dhfesta_logo_eng.7f6672ed.png";